import React from 'react';

import { CircleCheck } from 'lucide-react';
import { IconColors } from 'src/components/icons/icon-utils';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  icon: {
    '& circle': {
      stroke: IconColors.DarkGrey,
    },
    '& path': {
      stroke: IconColors.White,
    },
  },
});

interface CompleteReminderIconProps {
  size?: number;
}

export function CompleteReminderIcon({ size = 20 }: CompleteReminderIconProps): JSX.Element {
  const { classes } = useStyles();
  return <CircleCheck className={classes.icon} fill="#00A82D" size={size} />;
}
